define(['jquery', 'libs/jquery.ba-dotimeout'], function ($) {
	'use strict';

	var infinityscroll = {
		// summary:
		//		infinityscroll
		// description:
		//		A plugin that implements infinity scroll feature, with url updates and back-button support.
		//		@see: http://tumbledry.org/2011/05/12/screw_hashbangs_building
		// version:
		//		1.0.7


		requestInProgress: false,
		supportBackButton: 0, // THIS DOESN'T WORK YET, DON'T USE THIS SETTING.  1 = back button navigates WITHIN infinitely scrolling page. 0 = back button navigates to previous, referring page.
		urlCarryPageBase: null,
		itemCount: [],
		scrollDelay: 200,
		itemSelector: 'article',


		init: function () {
			if ($('[data-type="infinityscroll"]').data('itemselector') !== undefined) {
				this.itemSelector = $('[data-type="infinityscroll"]').data('itemselector');
			}
			this._initEvents();
		},


		pagerLoad: function () {
			var that = this,
				$pagerLink = $('[data-type="infinityscroll-pager"]');

			if ($pagerLink.length === 0) {
				return false;
			}

			if (($(document).scrollTop() + $(window).height() + 40) > $pagerLink.offset().top && this.requestInProgress === false) {
				var pagerUrl = $('[data-type="infinityscroll-pager"]').attr('href') || $('[data-type="infinityscroll-pager"]').find('a').attr('href');

				if ($pagerLink.length > 0 && $pagerLink.css('display') != 'none' && this.pathchange(pagerUrl)) {
					$.ajax({
						type: 'GET',
						url: pagerUrl,
						beforeSend: function () {
							that.requestInProgress = true;
							$pagerLink.addClass('is-loading').html('<i class="fa fa-spin fa-spinner"></i>');
						},
						success: function (data) {
							var filteredData = $(data).find('[data-type="infinityscroll"]').find(that.itemSelector + ', [data-type="infinityscroll-pager"]');
							that.itemCount.push(filteredData.length);
							$pagerLink.replaceWith(filteredData);
							that.requestInProgress = false;
						},
						dataType: 'html'
					});
				}
			}
		},


		pathchange: function (path) {
			var regexp = /\/[sida|sidor]\/([0-9]+)-?[0-9]*\/?$/,
				nextPage;

			// Query-based
			if (path.indexOf('?sida=') !== -1 || path.indexOf('&sida=') !== -1) {
				this.queryBased = true;
				regexp = /[sida|sidor]=([0-9]+)-?[0-9]*\/?$/;
			}

			if (this._detectHistorySupport()) {
				if (this.urlCarryPageBase === null) {
					if (regexp.test(window.location.href)) {
						nextPage = regexp.exec(window.location.href);
						this.urlCarryPageBase = nextPage[1];
					} else {
						nextPage = regexp.exec(path);
						this.urlCarryPageBase = nextPage[1] - 1;
					}
				}

				if (this.queryBased === true) {
					path = path.replace('sida=', 'sidor=' + this.urlCarryPageBase + '-');
				} else {
					path = path.replace('sida/', 'sidor/' + this.urlCarryPageBase + '-');
				}

				if (this.supportBackButton == 1) {
					window.history.pushState(null, null, path);
				} else {
					window.history.replaceState(null, null, path);
				}

				return true;
			} else {
				return false;
			}
		},


		_detectHistorySupport: function () {
			return !!(window.history && history.pushState);
		},


		_initEvents: function () {
			var that = this;

			$(window).scroll(function () {
				$.doTimeout('scroll', that.scrollDelay, $.proxy(that.pagerLoad(), that));

				if ($(document).height() - 200 > $(document).scrollTop() + $(window).height()) {
					that.scrollDelay = 200;
				}
			});

			window.onpopstate = function () {
				var lastTime;

				if (that.supportBackButton == 1) {
					if (that.itemCount.length > 0) {
						lastTime = that.itemCount.pop();
					}

					for (var i = 1; i <= lastTime; i++) {
						$('[data-type="infinityscroll"] > article').last().remove();
					}

					$('[data-type="infinityscroll-pager"]').show();
					that.scrollDelay = 3000;
				}
			};
		}
	};


	return infinityscroll;
});


//////////////////
// WEBPACK FOOTER
// ./components/infinityscroll/infinityscroll.js
// module id = 18
// module chunks = 0